import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {NgSelectComponent} from "@ng-select/ng-select";
import {CommonService} from "../services/common.service";
import {MultiselectItem} from "../../core/interfaces/admin.interface";

@Component({
  selector: 'app-headquarter-select',
  templateUrl: './headquarter-select.component.html',
  styleUrls: ['./headquarter-select.component.scss']
})
export class HeadquarterSelectComponent implements OnInit {

  @ViewChild("select")
  select: NgSelectComponent

  private companyId?: number

  loading = false;
  entries = [];
  selectedEntries: any = null;

  @Output() selectionChanged = new EventEmitter<number>();

  constructor(
    private service: CommonService,
  ) { }

  async ngOnInit() {
  }

  setCompanyHq(company: number, headquarter: number) {
    this.updateCompany(company, headquarter);
  }

  @Input() set company(company: number) {
    this.updateCompany(company, null)
  }

  private updateCompany(company: number, headquarter: number) {
    this.select.clearModel()
    const hqs = this.service.headquarters(company)
    this.entries = [...hqs]
    if(headquarter == null)
      this.selectedEntries = hqs.length > 0 ? hqs[0].id : null
    else
      this.selectedEntries = headquarter
    const hq = hqs.find(hq => hq.id == this.selectedEntries)
    this.onSelectionChange(hq)
  }

  onSelectionChange(id) {
    this.selectionChanged.emit(id)
  }

  @Input()get disabled(): boolean {
    return this.select.readonly
  }

  set disabled(value: boolean) {
    if(this.select) {
      this.select.readonly = value
    }
  }

  @Input() get key(): number {
    return this.selectedEntries
  }

  set key(id: number) {
    this.selectedEntries = id;
  }



}
